import { jsx as r } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import a from "../../Typography/Typography.js";
import m from "../../../../core/Context/useCoreContext.js";
import { TypographyElement as d, TypographyVariant as c } from "../../Typography/types.js";
/* empty css                        */
const h = "adyen-pe-data-overview-header", u = ({ baseClassName: e = h, children: t, hideTitle: p, titleKey: i, descriptionKey: o }) => {
  const { i18n: n } = m();
  return /* @__PURE__ */ r("header", { className: e, children: [
    /* @__PURE__ */ r("div", { className: `${e}__headings`, children: [
      !p && i && /* @__PURE__ */ r("div", { className: `${e}__title`, children: /* @__PURE__ */ r(a, { el: d.SPAN, variant: c.TITLE, medium: !0, children: n.get(i) }) }),
      o && /* @__PURE__ */ r("p", { className: `${e}__description`, children: /* @__PURE__ */ r(a, { el: d.SPAN, variant: c.BODY, children: n.get(o) }) })
    ] }),
    t && /* @__PURE__ */ r("div", { className: `${e}__controls`, children: t })
  ] });
};
export {
  h as BASE_CLASS,
  u as DataOverviewHeader
};
